import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useForm } from "@formspree/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Carousel from "./Carousel";
import bannerImgDes1 from "../../../Assets/Hompage/Banner/Banner (4).jpeg";
import bannerImgDes2 from "../../../Assets/Hompage/Banner/Banner (1).jpeg";
import bannerImgDes3 from "../../../Assets/Hompage/Banner/Banner (5).jpeg";
import bannerImgDes4 from "../../../Assets/Hompage/Banner/Banner (3).jpeg";
import bannerImgDes5 from "../../../Assets/Hompage/Banner/Banner (2).jpeg";
import mobileBanner1 from "../../../Assets/Hompage/Banner/Home Page-01_1080x960 px.jpg";
import mobileBanner2 from "../../../Assets/Hompage/Banner/Home page-05.jpg";
import mobileBanner3 from "../../../Assets/Hompage/Banner/Home page-04.jpg";
import mobileBanner4 from "../../../Assets/Hompage/Banner/Home Page-02.jpg";
import mobileBanner5 from "../../../Assets/Hompage/Banner/Home Page-03.jpg";
const Banner = () => {
  const [state, handleSubmit] = useForm("xknaznrw");

  if (state.succeeded) {
    return toast.success(
      "Thanks for submitting your Request.Our team will be notified as soon as Possible",
      {
        position: "top-center",
        // autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        autoplay: true,
        // autoplaySpeed: 2000,
        theme: "light",
      }
    );
  }

  const BannerImageDesktop = [
    {
      id: 1,
      ImgLink: "/Gallery",
      img: bannerImgDes1,
      title: "Matir Maya Eco Resort",
      details: "An oasis of elegance and nature where the soul meets the peace",
    },
    {
      id: 2,
      ImgLink: "/Gallery",
      title: "Matir Maya Eco Resort",
      img: bannerImgDes2,
      details: "An oasis of elegance and nature where the soul meets the peace",
    },
    {
      id: 3,
      ImgLink: "/Premium_Room",
      img: bannerImgDes3,
      title: "Matir Maya Eco Resort",
      details: "An oasis of elegance and nature where the soul meets the peace",
    },
    {
      id: 4,
      ImgLink: "/Swimming_Pool",
      img: bannerImgDes4,
      title: "Matir Maya Eco Resort",
      details: "An oasis of elegance and nature where the soul meets the peace",
    },
    {
      id: 5,
      ImgLink: "/Restaurant",
      img: bannerImgDes5,
      title: "Matir Maya Eco Resort",
      details: "An oasis of elegance and nature where the soul meets the peace",
    },
  ];

  const BannerImageMobile = [
    {
      id: 1,
      ImgLink: "/Gallery",
      img: mobileBanner1,
    },
    {
      id: 2,
      ImgLink: "/Gallery",
      img: mobileBanner2,
    },
    {
      id: 3,
      ImgLink: "/Premium_Room",
      img: mobileBanner3,
    },
    {
      id: 4,
      ImgLink: "/Swimming_Pool",
      img: mobileBanner4,
    },
    {
      id: 5,
      ImgLink: "/Restaurant",
      img: mobileBanner5,
    },
  ];

  return (
    <div className="lg:h-screen relative pb-0 md:pb-48">
      <div className="">
        <div className="hidden md:block desktop-version">
          <Carousel>
            {BannerImageDesktop.map((bannerImg) => (
              <div className="relative slider-section" key={bannerImg.id}>
                <Link to={bannerImg.ImgLink}>
                  <img
                    src={bannerImg.img}
                    alt="img1"
                    className="slider-section"
                  />
                </Link>
                <div className="carousel-caption absolute px-9 md:top-[20%] lg:top-[60%] lg:bottom-15 bottom-[20px] left-0 right-0 text-white hidden md:block">
                  <div className="pl-10">
                    <h2 className="lg:text-4xl xl:text-7xl text-base tracking-wide text-start text-white font-bold">
                      {bannerImg.title}
                    </h2>
                    <p className="lg:text-[20px] xl:text-[40px] text-base text-start md:max-w-3xl mt-5  leading-10 text-gray-200  font-serif   ">
                      {bannerImg.details}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
        {/* mobile version */}
        <div className=" md:hidden block mobile-version mt-20">
          <Carousel>
            {BannerImageMobile.map((mobileBannerImg) => (
              <div className="relative slider-section" key={mobileBannerImg.id}>
                <Link to={mobileBannerImg.ImgLink}>
                  <img
                    src={mobileBannerImg.img}
                    alt="img1"
                    className="slider-section"
                  />
                </Link>
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      {/* Booking Section */}
      <div className="booking-form absolute lg:bottom-0 left-0 right-0  hidden md:block lg:block px-1 lg:px-20 py-5">
        {/* action="https://formspree.io/f/xknaznrw" method="POST" */}
        <form onSubmit={handleSubmit}>
          <div className="grid md:grid-cols-3 lg:grid-cols-7 grid-cols-1 gap-5">
            <div className="w-full px-1">
              <div
                // action="https://formspree.io/f/xknaznrw"
                // method="POST"
                className=""
              >
                <label
                  for="fName"
                  className="mb-1 block text-[12px] font-medium text-white"
                >
                  Full Name:
                </label>
                <input
                  type="text"
                  name="Name"
                  id="fName"
                  required
                  placeholder="Full Name"
                  className="w-full text-sm rounded border border-[#f3ecec] bg-transparent py-1 px-6 font-medium text-white outline-none focus:border-[#6A64F1] focus:shadow-md"
                />
              </div>
            </div>
            <div className="w-full px-1">
              <div className="">
                <label
                  for="mNo"
                  className="mb-1 block text-[12px] font-medium text-white"
                >
                  Your Mobile No:
                </label>
                <input
                  type="text"
                  name="Mobile"
                  id="mNo"
                  required
                  placeholder="Your Mobile No"
                  className="w-full rounded border border-[#e0e0e0] bg-transparent py-1 px-6 text-sm font-medium text-white outline-none focus:border-[#6A64F1] focus:shadow-md"
                />
              </div>
            </div>
            <div className="w-full px-1">
              <div className="">
                <label
                  for="CheckIn-date"
                  className="mb-1 block text-[12px] font-medium text-white"
                >
                  Check in Date:
                </label>
                <input
                  type="date"
                  name="CheckIn-date"
                  id="date"
                  required
                  className="w-full rounded border border-[#e0e0e0] text-white py-1 px-6 text-sm font-medium bg-transparent outline-none focus:border-[#6A64F1] focus:shadow-md"
                />
              </div>
            </div>
            <div className="w-full px-1">
              <div className="">
                <label
                  for="date"
                  className="mb-1 block text-[12px] font-medium text-white"
                >
                  Check out Date:
                </label>
                <input
                  type="date"
                  required
                  name="CheckOut-date"
                  id="date"
                  className="w-full rounded border border-[#e0e0e0] text-white py-1 px-6 text-sm font-medium bg-transparent outline-none focus:border-[#6A64F1] focus:shadow-md"
                />
              </div>
            </div>

            <div className="">
              <label
                for="time"
                className="mb-1 block text-[12px] font-medium text-white"
              >
                Your Email:
              </label>
              <input
                type="email"
                name="CustomerEmail"
                id="time"
                required
                placeholder="your Email"
                className="w-full rounded border border-[#e0e0e0] text-white py-1 px-6 text-sm font-medium bg-transparent outline-none focus:border-[#6A64F1] focus:shadow-md"
              />
            </div>
            <div className="w-full px-1">
              <div className="">
                <label
                  for="guest"
                  className="mb-1 block text-[12px] font-medium text-white"
                >
                  Rooms:
                </label>
                <input
                  type="number"
                  name="Guest"
                  id="guest"
                  placeholder="5"
                  min="0"
                  className="w-full rounded border border-[#e0e0e0] bg-transparent py-1 px-6 text-sm font-medium text-white outline-none focus:border-[#6A64F1] focus:shadow-md"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={state.submitting}
              className="hidden lg:block text-center mt-5 text-white bg-orange-500 shadow-lg hover:text-white border border-orange-700 hover:bg-orange-800 font-medium rounded text-sm py-1 "
            >
              Booking
            </button>

            <div className="md:text-center md:block lg:hidden">
              <button
                type="submit"
                disabled={state.submitting}
                className=" px-2 mt-5 text-white bg-orange-500 shadow-lg hover:text-white border border-orange-700 hover:bg-orange-800 font-medium rounded text-sm py-1 text-start"
              >
                Booking
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Banner;
